module.exports = __webpack_public_path__ + "static/img/5836_phase_function_Paper_Points.b0a1d9e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5836_phase_function_Paper_Points.png
// module id = SpFL
// module chunks = 0